export enum ClientManagementTabStatus {
  all = 'All',
  active = 'Active',
  inactive = 'InActive',
}
